var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgOrangeStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 269,
    viewBox: "0 0 251 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1909 237.658L110.895 168.368L113.491 165.588V169.392V267.287H137.509V169.392V165.588L140.105 168.368L204.809 237.658L221.93 219.323L157.086 149.883L154.729 147.36H158.182H249.5V121.428H158.182H154.729L157.086 118.904L221.93 49.4644L204.809 31.1297L140.105 100.419L137.509 103.199V99.3953V1.5H113.491V99.3953V103.199L110.895 100.419L46.1909 31.1297L29.0697 49.4644L93.914 118.904L96.2708 121.428H92.8177H1.49998V147.36H92.8177H96.2708L93.914 149.883L29.0697 219.323L46.1909 237.658Z",
    fill: "#E0410E",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/OrangeStar.37b56d6109124bff0927409b65e6488a.svg";
export { ForwardRef as ReactComponent };